import { HttpClient } from '@angular/common/http';

import type { PageBuilderConfig } from '@jht/brand-page-builder/core';
import { firstValueFrom } from 'rxjs';

import { Config } from '../shared/config';
import { BUILDER_MANIFEST } from '../builder.manifest';
import {
    COLOR_CLASSES,
    SECTION_CLASS_OPTIONS,
    SECTION_CLASS_PRESETS,
} from './section-classes';

export const buildPageBuilderConfig = (
    config: Config,
    document: Document,
    http: HttpClient,
): PageBuilderConfig => ({
    manifest: BUILDER_MANIFEST,
    site: 'vision2',
    basePath: '/page-builder',
    apiBase: '/api',
    sectionClassPresets: SECTION_CLASS_PRESETS,
    sectionClassOptions: SECTION_CLASS_OPTIONS,
    defaultSectionClass: 'container py-4 py-lg-5',
    colorClasses: COLOR_CLASSES,
    cmsComponentNames: async () => {
        const { site_config_id } = await firstValueFrom(
            http.get<{ site_config_id: number }>('/api/pages/site'),
        );
        const definitions = await firstValueFrom(
            http.get<{ component_name: string }[]>(
                '/api/components/definitions',
                { params: { site_config_id } },
            ),
        );

        return definitions.map((definition) => definition.component_name);
    },
    cmsPageUrl: (page) => {
        const cmsUrl = config.environment?.cms_url;
        return cmsUrl
            ? `${cmsUrl}/vision2/pages/${page.id}?language_id=${page.languageId}`
            : '';
    },
    locale: () => ({
        region: config.region,
        language: config.getCurrentLanguage(),
    }),
    // Vision serves one region, so a live page is `{host}/{language}{path}` — the library's
    // default scheme puts the region in a subdomain, which this site has no equivalent of.
    liveUrl: (path, locale) =>
        `${document.location.origin}/${locale.language}${path}`,
});
